import GenerateQuestion from "../GenereteQuestion/GeneratQuestion";
import { Container, Row, Col, Button } from "react-bootstrap";
import SimulationBanks from "./SimulationBanks";
import ButtonSimulator from "./Components/Button/ButtonSimulator";
import SimulationInter from "./Components/InterCard/SimulationInter";
import ZustandSelectBankType from "../../Zustand/ZustandSelectBankType";
import SimulationInterMobile from "./Components/InterCard/SimulationInterMobile";
import "./Simulation.css";

const Simulation = (props) => {
  const { selectInter } = ZustandSelectBankType();

  return (
    <Container className="p-0 mt-4" fluid>
      {selectInter === "Multibancos" ? (
        <>
          <Container className="p-0 mt-4" fluid>
            <Col
              xs={13}
              lg={3}
              className="d-flex align-items-start p-0 mb-4 center-on-small"
            >
              <GenerateQuestion
                header="Sua simulação"
                subheader="Para fins de simulação apenas. Taxas e valores sujeitos à aprovação de crédito e às demais condições do produto vigentes no momento da contratação."
              />
            </Col>
            <Col
              xs={12}
              className="d-flex justify-content-center align-items-center p-0"
            >
              <SimulationBanks color={props.color} />
            </Col>
            <Col className="m-0">
              <ButtonSimulator color={props.color} />
            </Col>
          </Container>
        </>
      ) : (
        <>
          <Container className="custom-margin-left mt-4 p-0 mb-2" fluid>
            <Row className="d-flex align-items-start flex-wrap">
              <Col
                xs={6}
                lg={3}
                className="d-flex justify-content-center align-items-center  p-0 mx-2 mx-md-0"
              >
                <GenerateQuestion
                  header="Sua simulação"
                  subheader="Para fins de simulação apenas. Taxas e valores sujeitos à aprovação de crédito e às demais condições do produto vigentes no momento da contratação."
                />
              </Col>
              <Col
                xs={1}
                sm={1}
                md={1}
                lg={1}
                className="d-none d-md-block my-2 mx-1"
              ></Col>
              <Col
                className="d-none d-md-block"
                style={{ padding: "0px 0px 0px 16px" }}
              >
                <SimulationInter color={props.color} />
              </Col>
              <Col
                className="d-block d-md-none"
                style={{ padding: "0px 0px 0px 16px" }}
              >
                <SimulationInterMobile />
              </Col>
            </Row>
            <Col className="m-0">
              <ButtonSimulator color={props.color} />
            </Col>
          </Container>
        </>
      )}
    </Container>
  );
};

export default Simulation;
